import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f3541db"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Hívd meg egy rendezvényre. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Barátok vagytok a PartyBeast-en")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Barátkérelmet kaptál")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Elfogadom")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Elutasítom")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Barátkérelmet küldtél")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Adatvédelem")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Publikus profil ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Barátkérések fogadása ", -1))
const _hoisted_13 = { class: "ion-no-margin" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Mindenkitől")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Barátok barátaitól")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Senkitől")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " Meghívások fogadása ", -1))
const _hoisted_18 = { class: "ion-no-margin" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Mindenkitől")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Barátok barátaitól")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Senkitől")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("értesítések")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Bejelentkezés", -1))
const _hoisted_24 = { class: "ion-no-margin" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Mindig")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Cask gyanúsnál")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Soha")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Szórakozóhelyek", -1))
const _hoisted_29 = { class: "ion-no-margin" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Minden")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Csak fontosak")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Semmi")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Barátkérelmek", -1))
const _hoisted_34 = { class: "ion-no-margin" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Egyesével")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Naponta")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Soha")
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Javaslatok", -1))
const _hoisted_39 = { class: "ion-no-margin" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Hetente")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Havonta")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Soha")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Hírlevél", -1))
const _hoisted_44 = { class: "ion-no-margin" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Mindig")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Csak fontos")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Soha")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("app-információ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Verzió", -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode("fejlesztői menü")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "ServiceWorker törlése", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Újratöltés", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Kijelentkezés", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Menü elrejtése", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_action_sheet = _resolveComponent("ion-action-sheet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.profileModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": 
            _ctx.profileModal.presentingElement?.$el ||
            _ctx.$root.$refs.mainRouterOutlet.$el
        ,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("@" + _toDisplayString(_ctx.profileModal.chosenProfile.username), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "flex ion-justify-content-evenly ion-align-items-center" }, {
                    default: _withCtx(() => [
                      (_ctx.isOwnProfile)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 0,
                            icon: _ctx.createOutline,
                            class: "avatar-icon",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editActionSheetOpen = true))
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_avatar, { class: "avatar" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: 
                                    './assets/image/avatars/' +
                                    _ctx.profileModal.chosenProfile.username +
                                    '.jpg'
                                
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 1
                      }),
                      (_ctx.isOwnProfile)
                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            icon: _ctx.notificationsOutline,
                            class: "avatar-icon"
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "flex ion-align-items-center col" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.profileModal.chosenProfile.firstName +
                                    " " +
                                    _ctx.profileModal.chosenProfile.lastName), 1)
                      ]),
                      _hoisted_3,
                      _createElementVNode("small", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openActions && _ctx.openActions(...args)))
                      }, [
                        _createTextVNode(" @" + _toDisplayString(_ctx.profileModal.chosenProfile.username) + " ", 1),
                        _createVNode(_component_ion_icon, { icon: _ctx.ellipsisHorizontal }, null, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (
                            _ctx.profileModal.chosenProfile.hasBirthdayToday() &&
                            _ctx.profileModal.chosenProfile.isFriendsWith(1)
                        )
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.profileModal.chosenProfile.getBirthdayFormatted()), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Ma van " + _toDisplayString(_ctx.profileModal.chosenProfile.lastName) + " születésnapja", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_ctx.profileModal.chosenProfile.isFriendsWith(1))
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.profileModal.chosenProfile.lastName) + " és Te barátok vagytok ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (
                            _ctx.friendRequests.includes(
                                _ctx.profileModal.chosenProfile.id
                            )
                        )
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.profileModal.chosenProfile.lastName) + " felkért, hogy legyél a barátja ", 1),
                              _createVNode(_component_ion_buttons, { class: "ion-margin-top" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    color: "primary",
                                    fill: "clear"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_button, {
                                    color: "dark",
                                    fill: "clear"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (
                            _ctx.friendRequestsOutgoing.includes(
                                _ctx.profileModal.chosenProfile.id
                            )
                        )
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Várd meg, amíg " + _toDisplayString(_ctx.profileModal.chosenProfile.lastName) + " elfogadja a kérelmedet ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_ctx.isOwnProfile)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_grid, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { size: "10" }, {
                                            default: _withCtx(() => [
                                              _hoisted_11
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, { size: "1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_toggle, {
                                                checked: "",
                                                modelValue: _ctx.publicProfile,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.publicProfile) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_12
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_13, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everyone",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: 
                                                        _ctx.receiveFriendRequestsFrom
                                                    ,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
                                                        _ctx.receiveFriendRequestsFrom
                                                    ) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everyone" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_14
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_15
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_16
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_17
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_18, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everyone",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: _ctx.receiveInvitesFrom,
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiveInvitesFrom) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everyone" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_19
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_20
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_21
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_ctx.isOwnProfile)
                    ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _hoisted_22
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_grid, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_23
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_24, [
                                                _createVNode(_component_ion_select, {
                                                  value: "every-time",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: 
                                                        _ctx.receiveLoginNotifications
                                                    ,
                                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                                                        _ctx.receiveLoginNotifications
                                                    ) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "every-time" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_25
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_26
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_27
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_28
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_29, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everything",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: 
                                                        _ctx.receiveOrganiserNotifications
                                                    ,
                                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                                                        _ctx.receiveOrganiserNotifications
                                                    ) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everything" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_30
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_31
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_32
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_33
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_34, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everything",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: 
                                                        _ctx.receiveFriendRequests
                                                    ,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                                                        _ctx.receiveFriendRequests
                                                    ) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everything" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_35
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_36
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_37
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_38
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_39, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everything",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: _ctx.receiveSuggestions,
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receiveSuggestions) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everything" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_40
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_41
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_42
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_43
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", _hoisted_44, [
                                                _createVNode(_component_ion_select, {
                                                  value: "everything",
                                                  "ok-text": "Ok",
                                                  "cancel-text": "Mégse",
                                                  interface: "action-sheet",
                                                  modelValue: 
                                                        _ctx.receiveMarketingMail
                                                    ,
                                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                                                        _ctx.receiveMarketingMail
                                                    ) = $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_select_option, { value: "everything" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_45
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "blonde" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_46
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select_option, { value: "black" }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_47
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_ctx.isOwnProfile)
                    ? (_openBlock(), _createBlock(_component_ion_card, {
                        key: 0,
                        onClick: _ctx.versionClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _hoisted_48
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_grid, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _hoisted_49
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h6", null, _toDisplayString(_ctx.appVersion), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.dev)
                ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_subtitle, null, {
                                default: _withCtx(() => [
                                  _hoisted_50
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_grid, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { onClick: _ctx.swkrd }, {
                                            default: _withCtx(() => [
                                              _hoisted_51
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { onClick: _ctx.rld }, {
                                            default: _withCtx(() => [
                                              _hoisted_52
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, { onClick: _ctx.logout }, {
                                            default: _withCtx(() => [
                                              _hoisted_53
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_col, {
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dev = false))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_54
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "scrollfix" })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_action_sheet, {
            "is-open": _ctx.friendActionSheetOpen,
            buttons: _ctx.friendActionSheet,
            onDidDismiss: _cache[11] || (_cache[11] = ($event: any) => (_ctx.friendActionSheetOpen = false))
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_component_ion_action_sheet, {
            "is-open": _ctx.actionSheetOpen,
            buttons: _ctx.actionSheet,
            onDidDismiss: _cache[12] || (_cache[12] = ($event: any) => (_ctx.actionSheetOpen = false))
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_component_ion_action_sheet, {
            "is-open": _ctx.friendRequestActionSheetOpen,
            buttons: _ctx.friendRequestActionSheet,
            onDidDismiss: _cache[13] || (_cache[13] = ($event: any) => (_ctx.friendRequestActionSheetOpen = false))
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_component_ion_action_sheet, {
            "is-open": _ctx.ownActionSheetOpen,
            buttons: _ctx.ownActionSheet,
            onDidDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.ownActionSheetOpen = false))
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_component_ion_action_sheet, {
            "is-open": _ctx.editActionSheetOpen,
            buttons: _ctx.editActionSheet,
            onDidDismiss: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editActionSheetOpen = false))
          }, null, 8, ["is-open", "buttons"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}